import { Link } from "react-router-dom";
import { XCircle, ArrowRight } from "lucide-react";

export default function PaymentCancel() {
  return (
    <div data-testid="payment-cancel-page" className="sect-navy pt-32 pb-24 min-h-screen">
      <div className="bcu-container max-w-3xl">
        <div className="inline-flex items-center gap-2 px-3 py-1.5 border border-[rgba(255,255,255,0.14)] text-[#C7CFDD] text-[11px] tracking-[0.22em] uppercase rounded font-bold"><XCircle className="h-4 w-4" /> Payment canceled</div>
        <h1 className="mt-6 text-4xl md:text-6xl lg:text-7xl font-display leading-[1.02]">Checkout <span className="text-[#F7931E]">was canceled.</span></h1>
        <p className="mt-6 text-[#C7CFDD]">No charge was made. You can return to the enrollment page to complete your payment when you're ready.</p>
        <div className="mt-10 flex flex-wrap gap-4">
          <Link to="/enrollment" className="bcu-btn-primary">Return to enrollment <ArrowRight className="h-4 w-4" /></Link>
          <Link to="/" className="bcu-btn-secondary">Go home</Link>
        </div>
      </div>
    </div>
  );
}
